import React, { useEffect } from 'react';
import styled from 'styled-components';
import Highcharts from 'highcharts/highstock';

const Style = styled.div`
	width: 100%;
	background: ${props => props.theme.white};
	color: ${props => props.theme.defaultFontColor};

	#container {
		//border: 1px solid blue;
		height: 80px;
		margin-bottom: -10px;
	}
	#container2 {
		//border: 1px solid red;
		height: 80px;
		margin-top: -18px;
	}
	#container3 {
		//border: 1px solid red;
		height: 80px;
		margin-top: -28px;
	}
	#container4 {
		//border: 1px solid red;
		height: 80px;
		margin-top: -28px;
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

export const HorBarGraph = ({ cypressId, id, containerId, name, average, commit }) => {
	useEffect(() => {
		createBarGraph();
	}, [containerId]);
	function createBarGraph() {
		Highcharts.chart(containerId, {
			chart: {
				type: 'bar',
			},

			series: {
				lineColor: '#ffffff',
			},
			xAxis: {
				categories: [name],
				title: {
					text: null,
				},
				lineColor: '#ffffff',
			},
			yAxis: {
				min: 0,
				title: {
					text: '',
					align: 'high',
				},
				labels: {
					enabled: false,
				},
				gridLineColor: '#ffffff',
				lineColor: '#ffffff',
			},
			tooltip: {
				valueSuffix: 'kw',
			},
			plotOptions: {
				bar: {
					dataLabels: {
						enabled: true,
					},
				},
			},
			tickLength: 0,
			legend: {
				layout: 'vertical',
				align: 'right',
				verticalAlign: 'top',
				x: -40,
				y: 80,
				floating: true,
				borderWidth: 1,
				backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
				shadow: true,
			},
			credits: {
				enabled: false,
			},
			title: {
				text: '',
			},
			series: [
				{
					name: 'Average',
					data: [average],
					marker: {
						enabled: false,
					},
					pointWidth: 15,
					borderRadius: 5,
					color: '#d4d7d8',
					dataLabels: {
						enabled: true,
						style: {
							color: '#5b595b',
							textOutline: 'none',
							border: '0px',
						},
					},
				},
				{
					name: 'Committed',
					data: [commit],
					marker: {
						enabled: false,
					},
					pointWidth: 15,
					borderRadius: 5,
					color: '#00ad5c',
					dataLabels: {
						enabled: true,
						style: {
							color: '#5b595b',
							textOutline: 'none',
							border: '0px',
						},
					},
				},
			],
		});
	}
	return (
		<Style id={id} data-cy={cypressId} className='hor-bar-graph'>
			<div id={containerId}></div>
		</Style>
	);
};
